/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdminOutputDto } from '../model/adminOutputDto';
import { AdminRequestDto } from '../model/adminRequestDto';
import { AdminResponseDto } from '../model/adminResponseDto';
import { AdminTotalsDto } from '../model/adminTotalsDto';
import { AdminUpdatePassDto } from '../model/adminUpdatePassDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class AdminService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminChangePasswordPut(body?: AdminUpdatePassDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiAdminChangePasswordPut(body?: AdminUpdatePassDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiAdminChangePasswordPut(body?: AdminUpdatePassDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiAdminChangePasswordPut(body?: AdminUpdatePassDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Admin/ChangePassword`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminConfirmPost(body?: AdminRequestDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiAdminConfirmPost(body?: AdminRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiAdminConfirmPost(body?: AdminRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiAdminConfirmPost(body?: AdminRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/Admin/Confirm`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdAdmin 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminGetOneGet(cdAdmin?: number, observe?: 'body', reportProgress?: boolean): Observable<AdminOutputDto>;
    public apiAdminGetOneGet(cdAdmin?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminOutputDto>>;
    public apiAdminGetOneGet(cdAdmin?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminOutputDto>>;
    public apiAdminGetOneGet(cdAdmin?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdAdmin !== undefined && cdAdmin !== null) {
            queryParameters = queryParameters.set('cdAdmin', <any>cdAdmin);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminOutputDto>('get',`${this.basePath}/api/Admin/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminGetTotalsGet(observe?: 'body', reportProgress?: boolean): Observable<AdminTotalsDto>;
    public apiAdminGetTotalsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminTotalsDto>>;
    public apiAdminGetTotalsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminTotalsDto>>;
    public apiAdminGetTotalsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminTotalsDto>('get',`${this.basePath}/api/Admin/GetTotals`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminLoginPost(body?: AdminRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminResponseDto>;
    public apiAdminLoginPost(body?: AdminRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminResponseDto>>;
    public apiAdminLoginPost(body?: AdminRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminResponseDto>>;
    public apiAdminLoginPost(body?: AdminRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminResponseDto>('post',`${this.basePath}/api/Admin/Login`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdAdmin 
     * @param dsName 
     * @param dsEmail 
     * @param dsUsername 
     * @param dsNewLogo 
     * @param logo 
     * @param dsFb 
     * @param dsInsta 
     * @param dsTwitter 
     * @param dsYoutube 
     * @param dsSmsApi 
     * @param dsCurrency 
     * @param dsApiMeli 
     * @param dsMeliPublicKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminPutPutForm(cdAdmin?: number, dsName?: string, dsEmail?: string, dsUsername?: string, dsNewLogo?: string, logo?: Blob, dsFb?: string, dsInsta?: string, dsTwitter?: string, dsYoutube?: string, dsSmsApi?: string, dsCurrency?: string, dsApiMeli?: string, dsMeliPublicKey?: string, observe?: 'body', reportProgress?: boolean): Observable<AdminOutputDto>;
    public apiAdminPutPutForm(cdAdmin?: number, dsName?: string, dsEmail?: string, dsUsername?: string, dsNewLogo?: string, logo?: Blob, dsFb?: string, dsInsta?: string, dsTwitter?: string, dsYoutube?: string, dsSmsApi?: string, dsCurrency?: string, dsApiMeli?: string, dsMeliPublicKey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminOutputDto>>;
    public apiAdminPutPutForm(cdAdmin?: number, dsName?: string, dsEmail?: string, dsUsername?: string, dsNewLogo?: string, logo?: Blob, dsFb?: string, dsInsta?: string, dsTwitter?: string, dsYoutube?: string, dsSmsApi?: string, dsCurrency?: string, dsApiMeli?: string, dsMeliPublicKey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminOutputDto>>;
    public apiAdminPutPutForm(cdAdmin?: number, dsName?: string, dsEmail?: string, dsUsername?: string, dsNewLogo?: string, logo?: Blob, dsFb?: string, dsInsta?: string, dsTwitter?: string, dsYoutube?: string, dsSmsApi?: string, dsCurrency?: string, dsApiMeli?: string, dsMeliPublicKey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdAdmin !== undefined) {
            formParams = formParams.append('CdAdmin', <any>cdAdmin) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsEmail !== undefined) {
            formParams = formParams.append('DsEmail', <any>dsEmail) as any || formParams;
        }
        if (dsUsername !== undefined) {
            formParams = formParams.append('DsUsername', <any>dsUsername) as any || formParams;
        }
        if (dsNewLogo !== undefined) {
            formParams = formParams.append('DsNewLogo', <any>dsNewLogo) as any || formParams;
        }
        if (logo !== undefined) {
            formParams = formParams.append('Logo', <any>logo) as any || formParams;
        }
        if (dsFb !== undefined) {
            formParams = formParams.append('DsFb', <any>dsFb) as any || formParams;
        }
        if (dsInsta !== undefined) {
            formParams = formParams.append('DsInsta', <any>dsInsta) as any || formParams;
        }
        if (dsTwitter !== undefined) {
            formParams = formParams.append('DsTwitter', <any>dsTwitter) as any || formParams;
        }
        if (dsYoutube !== undefined) {
            formParams = formParams.append('DsYoutube', <any>dsYoutube) as any || formParams;
        }
        if (dsSmsApi !== undefined) {
            formParams = formParams.append('DsSmsApi', <any>dsSmsApi) as any || formParams;
        }
        if (dsCurrency !== undefined) {
            formParams = formParams.append('DsCurrency', <any>dsCurrency) as any || formParams;
        }
        if (dsApiMeli !== undefined) {
            formParams = formParams.append('DsApiMeli', <any>dsApiMeli) as any || formParams;
        }
        if (dsMeliPublicKey !== undefined) {
            formParams = formParams.append('DsMeliPublicKey', <any>dsMeliPublicKey) as any || formParams;
        }

        return this.httpClient.request<AdminOutputDto>('put',`${this.basePath}/api/Admin/Put`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
